import { Component, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'app-possible-na-multi-value-cell',
  templateUrl: './possible-na-multi-value-cell.component.html',
  styleUrls: ['./possible-na-multi-value-cell.component.scss'],
})
export class PossibleNaMultiValueCellComponent {
  @Input() public values: string[] = [];
  @Input() public toolTip: string;
  constructor(public hostElement: ElementRef<HTMLElement>) {}

  public get firstValue(): string | undefined {
    return this.values.length > 0 ? this.values[0] : undefined;
  }

  public get additionalValues(): string[] {
    return this.values.length > 1 ? this.values.slice(1) : [];
  }
}
